import { Decimal } from 'decimal.js';
import { numberUtils, constants } from '@zen/common-utils';

/**
 * Display the price, shows a hint if price is less than a kalapa
 *
 * @param {string|number} n
 * @returns {string}
 */
export function toDisplay(n, fractionDigits = constants.ZEN_DECIMAL_PLACES) {
  return new Decimal(n).lessThan(constants.MINIMUM_DIVIDED_UNIT)
    ? '(<) 0.00000001'
    : numberUtils.toDisplay(n, fractionDigits);
}
